import React from "react";
import { SimpleBarChart } from "@carbon/charts-react";
import PropTypes from "prop-types";
import { toolbarOptions } from "./utils";

const VerticalBarChart = ({
  height = "15rem",
  title = "Anomalías Mantenimiento",
  data = [
    {
      group: "VOLVO",
      key: "PYLL13",
      value: 129,
      al: 2558.8446253482,
      ecu_ambient_air_tmp: 22.2775703133,
      ecu_brake_pedal: 0,
      ecu_cool_tmp: 82.3149614935,
      ecu_def_level: 88.1544697366,
      ecu_dist__km: 152380.7101899721,
      ecu_eng_load: 88.156028231,
      ecu_fuel_iconsumption: 6632.0887289959,
      ecu_fuel_level_real: 625.9689463975,
      ecu_hours: 9642.4131049797,
      ecu_ins_efficiency: 27.3363228042,
      ecu_speed: 42.7324296074,
      ecu_rpm: 1323.7683641755,
      ecu_throttle: 55.5764615015,
      ecu_torque: 81.9728459371,
      ecu_weights: 43721.416123559,
      inclinacion: -1.0432958073,
      id: "1",
    },
  ],
  axisOptions = {
    left: {
      mapsTo: "value",
    },
    bottom: {
      scaleType: "labels",
      mapsTo: "key",
    },
  },
}) => {
  const state = {
    data,
    options: {
      title: `${title}`,
      axes: axisOptions,
      height: `${height}`,
      width: "95%",
      theme: "g100",
      tooltip: {
        customHTML: (data, defaultHtml) => {
          if (!data || data.length === 0) return defaultHtml;

          const item = data[0];
          const extraData = Object.entries(item)
            .filter(([key]) => !["group", "key", "value", "id"].includes(key))
            .map(
              ([key, value]) =>
                `<li>
                  <div class="datapoint-tooltip">
                    <div class="label">
                      <p>${key}</p>
                    </div>
                    <p class="value"/>${value}</p>
                  </div>
                </li>`
            )
            .join("");

          return defaultHtml.replace("</ul>", `${extraData}</ul>`);
        },
      },
      ...toolbarOptions,
    },
  };

  return <SimpleBarChart data={state.data} options={state.options} />;
};

VerticalBarChart.propTypes = {
  height: PropTypes.string,
  title: PropTypes.string,
  data: PropTypes.array,
  axisOptions: PropTypes.object,
};

export default VerticalBarChart;
